function getTypes(devs) {
  const _types = [
    { name: '虫情测报灯', key: 'tele' },
    { name: '气象监测站', key: 'mete' },
    { name: '性诱诱捕器', key: 'trap' },
    { name: '远程监控', key: 'camera' },
    { name: '智能孢子仪', key: 'spore' },
    { name: '赤霉病预警仪', key: 'wheatScab' }
  ]

  let obj = {}

  _types.forEach(o => {
    let d = devs.find(d => d.category === o.name)
    obj[`${o.key}`] = Boolean(d)
  })
  return obj
}

export function getHome(companyId, devices) {
  const pages = [
    { companyId: 27, page: '/home/preview' },
    { companyId: 29, page: '/home/wh' },
    { companyId: 34, page: '/home/wh2' },
    { companyId: 37, page: '/home/ls' },
    { companyId: 43, page: '/home/my1' },
    { companyId: 50, page: '/home/my2' },
    { companyId: 56, page: '/home/hs' },
    { companyId: 5, page: '/home/qingyuan' },
    { companyId: 71, page: '/home/hzyt' },
    { companyId: 62, page: '/home/gl' },
    { companyId: 69, page: '/home/jiangbei' },
    { companyId: 77, page: '/home/hj' },
    { companyId: 82, page: '/home/shouan' },
    // { companyId: 88, page: '/home/jxtjkj' },
    { companyId: 89, page: '/home/quanjiao' },
    { companyId: 105, page: '/home/shenuo' },
    { companyId: 117, page: '/home/lwc' },
    { companyId: 127, page: '/home/lwc' },
    { companyId: 147, page: '/home/lw' }
    // { companyId: 96, page: '/home/ningnan' }
  ]
  const page = pages.find(p => p.companyId === +companyId)

  if (page && page.page) {
    return page.page
  } else {
    const types = getTypes(devices)
    if (!(types.camera && types.spore && types.trap && types.wheatScab)) {
      return '/home'
    }
    return '/home'
  }
}

export function getLeft(id) {
  const exm = {
    88: 'jx'
  }
  return exm[+id] || 'default'
}
